// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__UqtsT","tag":"styles_tag__PRJkV"};